import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

interface ResponseDataShape {
	success: boolean
}

export async function inwardCashReceiptDeleteApi(
	payload: RequestDataShape,
	token: string,
) {
	const endpoint = "/inwardCashReceipt/delete/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	await requester.sendRequest(payload, token)
}
